import { gsap } from 'gsap';
export default class Archive {
    constructor() {
        this.init();
    }

    init() {
        if ($('.archive').length == 0) return;
        this.setAnime();
        this.setMixitup();
    }

    /**
     * ソート機能
     */
    setMixitup() {
        mixitup('.archive__list__content', {
            animation: { effects: 'fade' },
        });

        $('.js-pagenav-item span').on('click', function () {
            $('.js-pagenav-item span').removeClass('-active');
            $(this).addClass('-active');
        });
    }

    /**
     * ページ表示アニメ
     */
    setAnime() {
        gsap.set('.js-pagenav-item', { opacity: 0, transform: 'translate(0, 20px)' });
        gsap.set('.archive__list__thumb', { opacity: 0, transform: 'translate(0, 20px)' });

        this.tl = gsap.timeline();
        this.tl.call(this.showBtns.bind(this), null, null, 1).call(this.showThumbs.bind(this), null, null, 1.2);
    }

    showBtns() {
        gsap.to('.js-pagenav-item', { duration: 0.35, stagger: 0.1, opacity: 1, transform: 'translate(0, 0)', ease: 'power2.out' });
    }

    showThumbs() {
        const $thumbs = $('.archive__list__thumb');
        const ispc = window.matchMedia('only screen and (min-width: 769px)').matches;

        for (let i = 0; i < $thumbs.length; i++) {
            const _delay = ispc ? (i % 3) * 0.1 : 0;
            gsap.to($thumbs[i], { duration: 0.4, delay: _delay, opacity: 1, transform: 'translate(0, 0)', ease: 'power2.out' });
        }
    }
}
